import React, { useEffect } from 'react'

import { useSelector } from 'react-redux'

import { ApplicationState } from '@store/types'
import { Button } from '@interco/inter-ui/components/Button'
import { Colors } from '@utils/Colors'
import { Page } from '@templates'
import { validaEnvHomeByBridge } from '@utils/functions'
import { Timer } from '@signals'
import { Content } from '@organisms/SemEmprestimo/styles'
import { ColorWrapper, TextParagraph, GridStyled } from '@atoms'
import { BridgeService } from '@services/bridge'
import { useTrackingRefin } from '@hooks'
import { StepRefin } from '@utils/enums'
import Tag from '@utils/Tag'

const Indisponivel = () => {
  const { origemGoBack, isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  useTrackingRefin(StepRefin.INDISPONIVEL)

  useEffect(() => {
    BridgeService.tac({
      name: 'emprestimo-indisponivel',
      actions: ['autorizar_termo_emprestimo'],
      isError: true,
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:feedback',
        ref_type: '',
        content_action: 'Dado carregado',
        action_id: 'Empréstimo indisponível',
        section: 'feedback',
        sub_section: '',
        step: '',
        scenario: 'unavailable',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'page_loaded',
        element_name: 'Empréstimo indisponível',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'payrollloan:refin:feedback',
        section: 'feedback',
        sub_section: '',
        step: '',
        scenario: 'unavailable',
      })
    }
  }, [isApp])
  return (
    <Page
      footerTwoButtonsSpace="200px"
      showLeftIcon={false}
      stickyFooter={
        <Button
          variant="primary"
          onClick={() => {
            window.location.href = validaEnvHomeByBridge(String(origemGoBack), isApp) || ''
          }}
        >
          Ir para home
        </Button>
      }
    >
      <Content>
        <GridStyled margin="0">
          <Timer />
        </GridStyled>
        <ColorWrapper fontWeight="600" margin="24px 0 8px 0" style={{ textAlign: 'center' }}>
          <TextParagraph variant="headline-h1">Empréstimo indisponível</TextParagraph>
        </ColorWrapper>
        <ColorWrapper color={Colors.GRAY500} style={{ textAlign: 'center' }}>
          <TextParagraph variant="body-3" margin="10px 0 16px 0">
            Devido ao horário, não conseguimos dar sequência na contratação do empréstimo.
          </TextParagraph>
        </ColorWrapper>
        <ColorWrapper color={Colors.GRAY500} style={{ textAlign: 'center' }}>
          <TextParagraph variant="body-3">Por favor, retorne entre 06h e 22h</TextParagraph>
        </ColorWrapper>
      </Content>
    </Page>
  )
}

export default Indisponivel
